/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlContainment = {
    User: 'USER',
    Process: 'PROCESS',
    UserAgent: 'USER_AGENT',
    File: 'FILE',
    Endpoint: 'ENDPOINT',
    Location: 'LOCATION',
    Ip: 'IP',
    Domain: 'DOMAIN'
} as const;
export type ControlContainment = typeof ControlContainment[keyof typeof ControlContainment];


export function ControlContainmentFromJSON(json: any): ControlContainment {
    return ControlContainmentFromJSONTyped(json, false);
}

export function ControlContainmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlContainment {
    return json as ControlContainment;
}

export function ControlContainmentToJSON(value?: ControlContainment | null): any {
    return value as any;
}

